import { ThemeProvider } from "@emotion/react";
import { Backdrop, CircularProgress, createTheme } from "@mui/material";
import { setProgressState } from "clients/rest";
import { STheme } from "components/styles";
import { useRecoilState } from "recoil";
import { progressState } from "states/progressState";

type Props = {};

export const SProgress = (props: Props): JSX.Element => {
  const [prog, setProg] = useRecoilState(progressState);
  setProgressState(prog, setProg);
  return (
    <ThemeProvider theme={theme}>
      <Backdrop open={prog} sx={{ zIndex: 1000000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </ThemeProvider>
  );
};

const theme = createTheme(
  {
    components: {
      MuiBackdrop: {
        styleOverrides: {
          root: {
            backgroundColor: STheme.modals.backdrop,
            color: STheme.modals.text,
          },
        },
      },
    },
  },
  { ...STheme }
);
